import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NavParams, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { WebParameterContext } from '../../../model/common';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../service/messageclient.service';
declare var app;

@Component({
  selector: 'app-mz-modalpage',
  templateUrl: './mz-modalpage.page.html',
  styleUrls: ['./mz-modalpage.page.scss'],
})
export class MzModalpagePage implements OnInit {
  @Input() Param: any;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  PageNumber: any = 0;//页码
  loading: boolean = false;//加载效果
  apiObj = {
    status: false,
    msg: ''
  };//接口状态
  PageTitle: any = "请选择";
  searchValue: any = "";//查询值
  searchPlaceholder: any = "请输入";//查询提示
  DataArrayList: any = [];//列表数据
  CheckDataArrayList: any = [];//选中列表数据
  MultipleCheckDataArrayList: any = [];//多选时选中的值
  selectText:any = "请选择";
  selectId:any = null;
  selectCode:any = null;
  backUpDataList:any = [];//备份元数据
  constructor(
    public navParams: NavParams,
    public modalController: ModalController,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
  ) {
    // console.log(navParams.get("ConfigName"),navParams.get("PageName"));
  }

  ngOnInit() {
    console.log(this.Param, "init");
    this.PageTitle = this.Param["PageTitle"];
    this.searchPlaceholder = this.Param["Placeholder"];
    if (this.Param["defaultLoadData"] == undefined) {//默认加载数据
      this.Param["defaultLoadData"] = true;
    }
    if (this.Param["defaultLoadData"]) {
      this.LoadData(1);
    } else {
      this.loading = true;
      this.apiObj.status = false;
      this.apiObj.msg = this.searchPlaceholder + "进行搜索";
    }
  }

  /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e, type: string = 'type') {
    const that = this;
    if (e.keyCode == 13 || type == 'search') {
      // if ((that.Param.ConfigName == "QueryStoreInterface" || that.Param.ConfigName == "Contractquerystoreinterface" || that.Param.ConfigName == "Hospitalquerystoreinterface") && that.searchValue.trim() == "") {
      //   that.msg.Alert("请根据门店编码或名称进行搜索！");
      //   return;
      // }
      if (that.Param["Multiple"]) {//多选时，点击搜索，先保存已选中的值
        that.DataArrayList.forEach(item1 => {
          if (item1["isCheck"]) {
            let isPush = false;
            that.MultipleCheckDataArrayList.forEach(item2 => {
              if (item1.Id == item2.Id) {
                isPush = true;
              }
            })
            if (!isPush) {
              that.MultipleCheckDataArrayList.push(item1);
            }
          }
        })
      }
      that.DataArrayList = [];
      that.backUpDataList.forEach(item=>{
        if(item.item.Code.toLowerCase().indexOf(that.searchValue.toLowerCase()) > -1){
          that.DataArrayList.push(item);
        }
      })
      // this.LoadData(1);
    }
  }
  checkItem(item, i) {
    let that = this;
    if ((that.Param.ConfigName == 'QueryStoreInterface' || that.Param.ConfigName == "Hospitalquerystoreinterface" || that.Param.ConfigName == "Contractquerystoreinterface") && that.Param.OtherParam && that.Param.OtherParam["modelType"] == "ADD") {//hc审批，选择门店
      item["item"]["PGPeopleNums"] = item["item"]["PGPeopleNums"] || 0
      if (item["item"]["InStoreNum"] >= 2) {
      // if (item["item"]["InStoreNum"] >= item["item"]["PGPeopleNums"]) {
        that.msg.Alert("此门店可入PG人数已满，请核查门店信息是否正确");
        return;
      }
    }
    if (!that.Param["Multiple"]) {
      item["isCheck"] = true;
    } else {
      item["isCheck"] = !item["isCheck"];
    }
    that.DataArrayList.forEach((ckitem, index) => {
      if (!that.Param["Multiple"]) {
        ckitem["isCheck"] = false;
        if (item["Id"] == ckitem["Id"]) {
          item["isCheck"] = true;
        }
      }
    });
  }

  /**
   * 取消事件
   */
  dismissModal() {
    this.modalController.dismiss({
      'modalStatus': false
    });
  }
  /**
   * 确认事件
   */
  comfireModal() {
    const that = this;
    that.CheckDataArrayList = [];
    that.DataArrayList.forEach(item => {
      if (item["isCheck"]) {
        that.CheckDataArrayList.push(item);
      }
    })
    if (that.Param["Multiple"]) {//多选确定时，先把搜索之前已选中的值过滤
      that.MultipleCheckDataArrayList.forEach(item1 => {
        let isPush = false;
        that.CheckDataArrayList.forEach(item2 => {
          if (item1.Id == item2.Id) {
            isPush = true;
          }
        })
        if (!isPush) {
          that.CheckDataArrayList.push(item1);
        }
      })
    }
    console.log(that.CheckDataArrayList, "CheckDataArrayList");

    if (that.CheckDataArrayList.length > 0) {
      this.modalController.dismiss({
        'modalStatus': true,
        'info': that.CheckDataArrayList
      });
    } else {
      that.msg.Alert("请选择一项或取消返回上一页");
    }

  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.DataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }

  doRefresh(event) {
    if (this.Param["ConfigName"] == "QueryStoreInterface") {
      if (this.searchValue) {
        this.LoadData(1);
      }
    } else {
      this.LoadData(1);
    }
    event.target.pullMax = 500;
    event.target.pullMin = 100;
    event.target.complete();
  }

  /**
   * 获取数据
   */
  LoadData(PageNumber) {
    const that = this;

    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const PageName = that.Param.PageName;
    const id = that.Param.id;
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.ConfigName = that.Param.ConfigName;
    body.OpType = "GET";
    body.ConfigType = "view";
    body.PageNumber = PageNumber;
    body.RowsPerPage = this.Param["RowsPerPage"] || app.RowsPerPage;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.Param["SpecialParameter"]) {
      body["SpecialParameter"] = that.Param["SpecialParameter"];
    }
    let _obj = {};
    _obj = JSON.parse(JSON.stringify(that.Param.OtherParam));
    if (that.searchValue && that.Param["SearchField"]) {
      if (that.Param["SearchType"]) {
        _obj[that.Param["SearchField"]] = that.com.LikeSearch(that.searchValue.trim());
      } else {
        _obj[that.Param["SearchField"]] = that.searchValue.trim();
      }
    } else {
      delete _obj[that.Param["SearchField"]];
    }

    if(that.Param['PageName'] == 'changePOSMPhoto' && that.selectCode){
      _obj["ProvinceID"] = that.selectId;
    }
    // if (that.Param.ConfigName == 'QueryStoreInterface') {
    //   delete _obj["modelType"];
    // }
    if (that.Param.ConfigName == 'MPGQueryDealerInterface') {
      if (!_obj["Search"]) {
        _obj["Search"] = "";
      }
    }
    body.RequestBody = JSON.stringify(_obj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      // if (PageNumber == 1) {
      //   that.DataArrayList = [];
      //   that.apiObj['status'] = data.ResponseMessage.Success;
      //   that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      //   that.loading = true;
      // } else {
      //   that.infiniteScroll.complete();
      // }
      /****判断是否第一页end****/
      that.apiObj['status'] = data.ResponseMessage.Success;
      that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
      that.loading = true;
      if (data.ResponseMessage.Success) {
        data.Status.data.forEach(item => {
          let isPush = false;
          that.Param["dataList"].forEach(item2=>{
            if(item2.ProductID == item.ID){
              isPush = true;
            }
          })
          if(!isPush){
            let _name = "";
            that.Param.Name.forEach(item2 => {
              if (_name) {
                _name += "-" + (item[item2] || "--");
              } else {
                _name = (item[item2] || "--");
              }
            })
            const _obj = {
              Id: item[that.Param.Id],
              Name: _name,
              item: item
            }
            that.DataArrayList.push(_obj);
          }
        })
        if (that.Param["Multiple"]) {//多选时，如果获取到的列表有已选中的
          that.DataArrayList.forEach(item1 => {
            that.MultipleCheckDataArrayList.forEach(item2 => {
              if (item1.Id == item2.Id) {
                item1["isCheck"] = true;
              }
            })
          })
        }
        // if((that.Param["PageName"] == "ActivityCenterDetail1" || that.Param["PageName"] == "ActivityCenterDetail3") && that.Param["ConfigName"] == "TBStoreApp"){
        //   if(that.DataArrayList["Id"] != "noStore"){
        //     that.DataArrayList.unshift({
        //       Id:"noStore",
        //       Name:"无",
        //       item:{}
        //     })
        //   }
        // }
        /****上拉加载数据begin****/
        that.backUpDataList = JSON.parse(JSON.stringify(that.DataArrayList));
        // that.RecordCount = data.Status.RecordCount || 0;
        // if (that.RecordCount == data.Status.data.length || that.RecordCount == that.DataArrayList.length) {
        //   that.infiniteScroll.disabled = true;
        // } else {
        //   that.infiniteScroll.disabled = false;
        // }
        /****上拉加载数据end****/
      } else {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = "网络繁忙，请稍后再试！";
      that.loading = true;
      console.log(error);
    });
  }


  async selectModel() {
    let that = this;
    const modal = await that.modalController.create({
      component: MzModalpagePage,
      componentProps: {
        "Param": {
          "Multiple": false,//是否多选，必填
          "SearchType": true,//是否模糊查询（有的接口已经处理过，不需要模糊查询）
          "SearchField": "a_Name",//查询字段，必填（不需要查询为""）
          "ConfigName": "TBProvinceXML",//接口configname，必填
          "PageName": "changePOSMPhotoProvince",//页面名称，非必填
          "PageTitle": "请选择省份",//页面title，非必填
          "Placeholder": "请输入省份名称",//查询框占位符，非必填
          "Id": "a_ID",//查询列表唯一标识字段，必填
          "Name": ["a_Name", "a_Code"],//页面显示字段，必填
          "RowsPerPage":20,
          "OtherParam": {//接口requestbody参数，必填

          }
        }
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    if (data["modalStatus"]) {
      console.log(data);
      that.selectId = data["info"][0]["item"]["a_ID"];
      that.selectCode = data["info"][0]["item"]["a_Code"];
      that.selectText = data["info"][0]["item"]["a_Name"];
      that.LoadData(1);
    }
  }
  clear() {
    this.selectId = null;
    this.selectCode = null;
    this.selectText = "请选择";
    this.LoadData(1);
  }
}
